export default __webpack_public_path__ + "static/media/2020_Chang_et_al_2020_EcologicalModelling.6b4661b3.pdf";